<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div class="flex justify-center m-8">
        <img src="@/assets/images/logo/LogotipoCompleto.png" width="400" alt="FastWay"/>
      </div>
      <div class="flex justify-center m-8">
        <h2><b>Backend Tienda en línea SBG</b></h2>
      </div>
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2">
              <div class="p-8 login-tabs-container">

<!--
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Acceso</h4>
                  <p>Por favor seleccione el método de acceso</p>
                </div>
-->

                  <div class="social-login-buttons flex justify-center items-center m-4">
                    <div class="flex flex-row items-center bg-google rounded-lg cursor-pointer mr-8 h-16" @click="loginWithGoogle">
                      <img class="m-2 h-12" src="@/assets/images/logo/GoogleIcon.png" alt="Acceso por Google">
                      <div class="h-full w-px bg-white"></div>
                      <div class="flex text-white items-center text-md m-4 border-l-2 border-white">Acceder con Google</div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      validationCode: ''
    };
  },
  methods: {
    loginWithGoogle () {
      this.$store.dispatch('auth/loginWithGoogle', { notify: this.$vs.notify });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
</style>
